import React from "react";
import { Link } from "react-router-dom";
import sidebarHelper from "../../../helpers/sidebar";

function SiteAdvertiseMenuCustomer({ openItem = null, activeItem = null }) {
  return (
    <>
      <li
        className={`nav-item has-treeview 
          ${sidebarHelper.checkOpenItem(openItem, "all-advertise-customer")} `}
      >
        <a
          href="# "
          className={`nav-link  
          ${sidebarHelper.checkActiveItem(
            openItem,
            "all-advertise-customer"
          )} `}
        >
          <i class="nav-icon hl-advertise align-middle "></i>
          <p>
            تبلیغات
            <i className="right fa fa-angle-left"></i>
          </p>
        </a>

        <ul className="nav nav-treeview">
          <li className="nav-item">
            <Link
              to="/advertise/customer/banner/all"
              className={`nav-link  
              ${sidebarHelper.checkActiveItem(
                activeItem,
                "all-advertise-banner-customer"
              )} `}
            >
              <i className="hl-add-banner nav-icon nav-icon"></i>
              <p>تبلیغات بنری</p>
            </Link>
          </li>

          <li className="nav-item">
            <a className="nav-link   d-flex justify-content-between">
              <span>
                <i className="hl-ad-native nav-icon"></i>
                <p>تبلیغات همسان</p>
              </span>
              <span className="badge badge-success">به زودی</span>
            </a>
          </li>

          <li className="nav-item">
            <a className="nav-link   d-flex justify-content-between">
              <span>
                <i className="hl-ad-push nav-icon"></i>
                <p>تبلیغات پوش</p>
              </span>
              <span className="badge badge-success">به زودی</span>
            </a>
          </li>
        </ul>
      </li>
    </>
  );
}

export default SiteAdvertiseMenuCustomer;
